import { AccentTextUnbound } from './AccentTextUnBound';
import React from 'react';

export const formatDurationMinutes = minutes => {
    if (minutes === null || minutes === undefined) return "";

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return [
        hours > 0 ? `${hours}h` : null,
        remainingMinutes > 0 || hours === 0 ? `${remainingMinutes}m` : null
    ].filter(Boolean).join(" ");
};

export const parseDurationMinutes = value => {
    const text = String(value ?? "").trim().toLowerCase();
    if (text === "") return null;
    if (/^\d+$/.test(text)) return Number(text);

    const match = text.match(/^(?:(\d+(?:\.\d+)?)\s*h(?:rs?|ours?)?)?\s*(?:(\d+)\s*m(?:ins?|inutes?)?)?$/);
    if (!match || (!match[1] && !match[2])) return undefined;
    return Math.round(Number(match[1] ?? 0) * 60) + Number(match[2] ?? 0);
};

export const AccentDurationUnbound = ({
    defaultValue,
    onChange,
    disabled,
    maxMinutes,
    dataTagName,
    label
}) => {
    const [refreshKey, setRefreshKey] = React.useState(0);

    const parseAndClamp = value => {
        const parsed = parseDurationMinutes(value);
        if (parsed === undefined || parsed === null) return parsed;
        return Math.min(maxMinutes ?? Number.MAX_SAFE_INTEGER, Math.max(0, Math.round(parsed)));
    };

    return (
        <AccentTextUnbound
            key={refreshKey}
            label={label}
            disabled={disabled}
            dataTagName={dataTagName}
            defaultValue={formatDurationMinutes(defaultValue)}
            resetWhenDefaultValueChanges
            placeHolder="e.g. 1h 30m"
            onValidate={value => parseDurationMinutes(value) === undefined ? "Enter a duration like 1h 30m" : null}
            onBlur={value => {
                const durationMinutes = parseAndClamp(value);
                if (durationMinutes !== undefined) {
                    onChange?.(durationMinutes);
                    setRefreshKey(key => key + 1);
                }
            }}
        />
    );
};
